import { panelOpen, escalationView, escalationSent, operatorLive } from "../store";
import { SPARK, PERSON, CLOSE } from "./icons";

export function ChatHeader() {
  const live = operatorLive.value;
  return (
    <div class="ic-header">
      <div class="ic-avatar">
        {live ? PERSON : SPARK}
        {live && <span class="ic-avatar-dot" />}
      </div>
      <div class="ic-header-text">
        <div class="ic-name">{live ? "Badstugutta" : "Iskra"}</div>
        <div class="ic-status" role="status">
          {live ? "Et menneske fra oss har tatt over" : "Digital assistent · svarer med en gang"}
        </div>
      </div>
      <button
        class="ic-close"
        onClick={() => {
          panelOpen.value = false;
          escalationView.value = false;
          // Samme som «Lukk» på takk-skjermen, så neste åpning starter i chatten.
          escalationSent.value = false;
        }}
        aria-label="Lukk chat"
      >
        {CLOSE}
      </button>
    </div>
  );
}
